export default {
    methods: {
        getContentDispositionFileName(headers) {
            const contentDisposition = headers.get("content-disposition");
            if (contentDisposition) {
                const attachment = contentDisposition
                    .split(";")
                    .find(item => item.includes("filename="));

                if (attachment) {
                    const filename = attachment.split("=").pop();
                    return filename || "";
                }
                return "";
            }
            return "";
        },
        downloadURI(uri, name) {
            const link = document.createElement("a");
            link.download = name;
            link.href = uri;
            link.click();
        },
        downloadFileFromContentDisposition(response) {
            const filename = this.getContentDispositionFileName(
                response.headers
            );
            if (filename) {
                this.downloadURI(response.body, filename);
            } else {
                console.error(
                    "Failed to retrieve filename from content-disposition"
                );
            }
        }
    }
};
